import { useFilter } from 'shared/common/OpenFiltersButton/hooks/useFilter'
import { ParamKey } from 'shared/types/QueryModel'

import { ReactNode } from 'react'

import { Checkbox } from 'shared/ui/Form/Checkbox'

export interface CheckboxOption {
  label: string
  value: string
  prefix?: ReactNode
}

interface CheckboxOptionsProps {
  options: CheckboxOption[]
  paramKey?: ParamKey
  selectedValues?: string[]
}

export const CheckboxOptions = ({
  options,
  paramKey,
  selectedValues = [],
}: CheckboxOptionsProps) => {
  const { filters } = useFilter()

  return options.map((checkbox) => {
    const isChecked = paramKey
      ? filters?.[paramKey]?.split(',').includes(checkbox.value)
      : selectedValues.includes(`${checkbox.value}`)

    return {
      label: (
        <div>
          <Checkbox
            className="w-full gap-[2px]"
            checked={isChecked}
          >
            <div className="flex items-center gap-[10px] text-dark leading-[20px] text-[14px] whitespace-break-spaces">
              {checkbox?.prefix}
              {checkbox.label}
            </div>
          </Checkbox>
        </div>
      ),
      value: checkbox.value,
    }
  })
}
